import {Injectable} from "@angular/core";
import {HomepageQuestionModel} from "../../../models/homepageQuestion.model";
import {FrequentlyAskedQuestionsComponent} from "./frequently-asked-questions.component";

@Injectable()
export class FrequentlyAskedQuestionsFactory {
  public static questions = [
    [
      new HomepageQuestionModel(1, 'home-page-content.question', 'questions_content.answer', false),
      new HomepageQuestionModel(2, 'home-page-content.question_1', 'questions_content.answer1', false),
      new HomepageQuestionModel(3, 'home-page-content.question_2', 'questions_content.answer2', false),
      new HomepageQuestionModel(4, 'home-page-content.question_3', 'questions_content.answer3', false),
    ],
    [
      new HomepageQuestionModel(5, 'home-page-content.question_4', 'questions_content.answer4', false),
      new HomepageQuestionModel(6, 'home-page-content.question_5', 'questions_content.answer5', false),
      new HomepageQuestionModel(7, 'home-page-content.question_6', 'questions_content.answer6', false),
      new HomepageQuestionModel(8, 'home-page-content.question_7', 'questions_content.answer7', false),
    ]
  ];
}
